import { render, staticRenderFns } from "./StripeElements.vue?vue&type=template&id=0123a97c&"
import script from "./StripeElements.vue?vue&type=script&lang=js&"
export * from "./StripeElements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports